module.exports = __webpack_public_path__ + "static/img/8.af0be863.jpg";